import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../store/langSlice';
import { getLang } from '../../../environnement';

export default function StatutDialog({
  open,
  numeroDemande,
  handleClose,
}) {
  const lang = useSelector(langSelector);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{paddingBottom: '0px'}}
    >
      <DialogTitle id="alert-dialog-title">
        <p className='text-2xl sm:text-3xl font-medium font-inter mt-5' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).reservationSalle.statutDialogTitle} {numeroDemande}</p>
        
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <p className='text-2xl sm:text-3xl font-regular font-inter text-red' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).reservationSalle.statutDialgoContent}</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className='flex justify-end px-5 w-full'>
          <div
            className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-[180px]'
            onClick={handleClose}
          >
            <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).reservationSalle.confirmer}</p>
          </div>

        </div>
      </DialogActions>
    </Dialog>
  );
}
